import {createPlanetTheme} from '@apps-common/ui-theme/Themes.js';
import {componentOverrides} from './overrides.js';

export const THEME_MODE = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system',
};

export const theme = createPlanetTheme({
  colorScheme: THEME_MODE.LIGHT,
  extendedConfig: {
    colorSchemes: {
      light: {
        palette: {
          DataGrid: {
            headerBg: 'grey.100',
          },
        },
      },
      dark: {
        palette: {
          DataGrid: {
            headerBg: '#23343F',
          },
        },
      },
    },
    components: componentOverrides,
  },
});
